<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<button type="button" class="btn btn-primary btn-ico" [ngbTooltip]="'EDIT_BUTTON.EDIT' | translate" container="body">
  <i class="fal fa-pencil"></i>
</button>
